import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Script from 'next/script'
import { Inter, Manrope } from 'next/font/google'

import { JsonLd } from '@/components/seo/JsonLd'

const manrope = Manrope({
    subsets: ['latin'],
    weight: ['400', '500', '600', '700', '800'],
    variable: '--font-manrope',
    display: 'swap'
})

const inter = Inter({
    subsets: ['latin'],
    weight: ['400', '500', '600', '700'],
    variable: '--font-inter',
    display: 'swap'
})

const App: FC<AppProps> = ({ Component, pageProps, router }): ReactNode => {
    // Directory pages render one connected JSON-LD graph that already includes
    // the agency and website nodes, so the site-wide graph is skipped there.
    const ownGraph = router.pathname.startsWith('/construction-companies')

    return (
        <div className={`${manrope.variable} ${inter.variable} font-sans antialiased`}>
            <a
                href='#main'
                className='sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-full focus:bg-ink focus:px-4 focus:py-2 focus:text-white'
            >
                Skip to content
            </a>

            <Component {...pageProps} />

            {ownGraph ? null : <JsonLd />}

            {/* Google Analytics 4 */}
            <Script
                src='https://www.googletagmanager.com/gtag/js?id=G-GGB7BVSS6P'
                strategy='afterInteractive'
            />
            <Script id='ga4-init' strategy='afterInteractive'>
                {`
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());
                    gtag('config', 'G-GGB7BVSS6P');
                `}
            </Script>

            <Script
                src='https://assets.calendly.com/assets/external/widget.js'
                strategy='afterInteractive'
            />
        </div>
    )
}

export default App
